import { useCallback } from 'react';
import { getCoreEditorRef } from '../../context/editorV2/CoreEditorContext';
import { EditorState } from '../../store/EditorSlice';

const useEditorFormattedText = () => {
  const coreEditor = getCoreEditorRef();

  const getFormattedText = useCallback(
    ({
      canAccessCuesMode,
      renderMode,
    }: {
      canAccessCuesMode: boolean;
      renderMode: EditorState['renderMode'];
    }) => {
      // Find formatted text based on core editor state
      let formattedText: string | undefined;
      let shouldBeSingleTakeOnly = false;
      // Note: this flag is based on project version
      if (canAccessCuesMode) {
        // For now, cues mode is only supported in single take render mode
        if (renderMode === 'all') {
          formattedText = coreEditor?.helpers.getXml();
          shouldBeSingleTakeOnly = true;
        } else {
          // handle phonetic replacement for other render modes
          formattedText = coreEditor?.helpers.performReplacement(true);
        }
      } else {
        // handle phonetic replacement for Editor V2 without Cues
        formattedText = coreEditor?.helpers.performReplacement(false);
      }
      const textFormat = formattedText ?? '';

      return {
        textFormat,
        shouldBeSingleTakeOnly,
      };
    },
    [coreEditor]
  );

  return [getFormattedText];
};

export default useEditorFormattedText;
